// @flow

// the  following functions take moments and return strings in
// the formats returned by the Minibar API
export const serverTimeFormat = date_moment => date_moment.format('YYYY[-]MM[-]DD[T]HH[:]mm[:]ssZ');
export const serverDateFormat = date_moment => date_moment.format('YYYY[-]MM[-]DD');

// the following functions take moments and a number and return moments
export const daysFromDate = (date_moment, days_ahead) => date_moment.clone().add(days_ahead, 'days');
export const hoursFromDate = (date_moment, hours_ahead) => date_moment.clone().add(hours_ahead, 'hours');
